const fonts = {
	ppSansBigRegular: 'pp-sans-big-regular',
	ppSansBigMedium: 'pp-sans-big-medium',
	ppSansBigLight: 'pp-sans-big-light',
	ppSansSmallRegular: 'pp-sans-small-regular',
	ppSansSmallMedium: 'pp-sans-small-medium',
	ppSansSmallLight: 'pp-sans-small-light'
}

export default fonts;



// WEBPACK FOOTER //
// ./styles/fonts.js